export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/plusCircleGreyIcon.92e0f240.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};